import { requester } from "src/libraries/requester";
import { links } from "src/Links";
import { INewsCategoryClient } from "./INewsCategoryClient";
import { ApiService } from "src/repository/ApiService";
import { newsCategoryClientModel } from "./NewsCategoryClientModel";

export const newsCategoryClientService = new ApiService<INewsCategoryClient>(requester, links.newsCategoryClient, newsCategoryClientModel);
